import { useState, useEffect } from 'react';
import './style.scss';
import { TranslationService } from '../../services/translation.service';
import { ClientSideStorageService } from '../../services/client-side-storage.service';
import { SanitizerService } from '../../services/sanitizer.service';

function CookieConsent() {
  const cookiePageUrl = TranslationService.get('common.cookiepageurl');
  const [show, setShow] = useState(false);
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  };

  useEffect(() => {
    const fetchData = async () => {
      setShow(!ClientSideStorageService.isConsentStatusSet() && window.location.pathname !== cookiePageUrl);
    };
    fetchData();
  }, [cookiePageUrl]);

  useEffect(() => {
    const handleHideCookieConsent = () => {
      setShow(false);
    };
    document.addEventListener('hide-cookie-consent', handleHideCookieConsent);

    return () => {
      document.removeEventListener('hide-cookie-consent', handleHideCookieConsent);
    };
  }, []);

  function handleApproveAllClick() {
    const success = ClientSideStorageService.approveAll();
    setShow(!success);
    fetch(`/api/cookieselector/all${!success ? '?success=false' : ''}`, requestOptions);

    if (success) {
      document.dispatchEvent(new CustomEvent('consent-status-approved'));
    }
  }

  function handleApproveNecessaryClick() {
    const success = ClientSideStorageService.approveNecessary();
    setShow(!success);
    fetch(`/api/cookieselector/necessary${!success ? '?success=false' : ''}`, requestOptions);
  }

  function handleManageClick() {
    fetch('/api/cookieselector/manage', requestOptions);
  }

  return (
    show && (
      <div className="fixed-bottom cookie-consent py-4 bg-gray">
        <div className="container container--wide">
          <div className="row">
            <div className="col-12 col-md-6 mb-2 mb-md-0">
              <div dangerouslySetInnerHTML={{ __html: SanitizerService.sanitizeHtml(TranslationService.get('common.cookieconsenttext')) }}></div>
            </div>
            <div className="col-12 col-md-6 d-flex align-items-center justify-content-between flex-column flex-lg-row">
              <a href={`${cookiePageUrl}#anpassa`} className="btn btn-secondary btn-sm flex-fill cookie-consent__btn" onClick={handleManageClick}>
                {TranslationService.get('common.managecookies')}
              </a>
              <button type="button" className="btn btn-primary btn-sm flex-fill mx-lg-2 my-2 my-lg-0 cookie-consent__btn" onClick={handleApproveNecessaryClick}>
                {TranslationService.get('common.approvenecessarycookies')}
              </button>
              <button type="button" className="btn btn-primary btn-sm flex-fill cookie-consent__btn" onClick={handleApproveAllClick}>
                {TranslationService.get('common.approveallcookies')}
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  );
}

export default CookieConsent;
